import {createContext, useContext, useMemo} from "react";
import {useOutletContext} from "react-router-dom";

const ProductEditContext = createContext(null);

export const ProductEditProvider = ({value, children}) => {
    const memoizedValue = useMemo(() => value, [value]);
    return (
        <ProductEditContext.Provider value={memoizedValue}>
            {children}
        </ProductEditContext.Provider>
    );
};

export const useProductEditContext = () => {
    const outletContext = useOutletContext();
    const context = useContext(ProductEditContext);
    return outletContext ?? context ?? {};
};

export const useProductEditId = () => {
    const {productId} = useProductEditContext();
    return productId ?? null;
};

export const useProductEditCompanyId = () => {
    const {companyId} = useProductEditContext();
    return companyId ?? null;
};

export const useProductEditLocation = () => {
    const {location} = useProductEditContext();
    return location ?? {pathname: "", search: "", hash: ""};
};

export const useProductEditNavigate = () => {
    const {navigate} = useProductEditContext();
    return navigate ?? (() => {});
};

export const useProductEditPanelZIndexes = () => {
    const {panelZIndexClass = null, overlayZIndexClass = null} = useProductEditContext();
    return {panelZIndexClass, overlayZIndexClass};
};

export default ProductEditContext;
